// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sxHb9","questions":"styles_questions__13ffl","footer":"styles_footer__3drtk"};